import React, { useState, useRef } from 'react';
import PageManageModal from '../../../molecules/page-manage/page-manage-modal';
import styles from './styles.scss';
import { ManageThankYouConsumer } from '../thank-you-manage-view/ThankYouManageContext';

const ThankYouCreateModal = function ThankYouCreateModal() {
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState('');
    const [newTitle, _setNewTitle] = useState('');
    const [disableConfirm, setdisableConfirm] = useState(false);

    const newTitleRef = useRef(newTitle);
    const setNewTitle = (value) => {
        newTitleRef.current = value;
        _setNewTitle(value);
    };

    const modalButton = (
        <button className={`button is-primary ${styles['thank-you-create-modal']} ${styles['is-large-override']}`} type="button" style={{ marginBottom: 5 }} onClick={() => setShowModal(true)}>
            Create New Page
        </button>
    );

    const clickHandler = (list, updateList) => {
        const { protocol, host } = new URL(window.location.href);
        const query = `${protocol}//${host}/odata/thankyoupages`;
        setdisableConfirm(true);

        const formData = new FormData();
        formData.append('title', newTitle);

        fetch(query, { method: 'POST', body: formData })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }

                throw Error(response.statusText);
            })
            .then((page) => {
                if (window.self !== window.top) {
                    window.parent.postMessage(['redirectToEdit', page.Path, page.AppealUUID], '*');
                } else {
                    const newList = [...list];
                    newList.unshift(page);
                    updateList(newList);

                    setNewTitle('');
                    setError('');
                    setShowModal(false);
                    setdisableConfirm(false);
                }
            })
            .catch((err) => {
                setdisableConfirm(false);
                setError(`Something went wrong. Please try again later - ${err}`);
            });
    };

    const getSubmit = (pages, setPages) => {
        if (!newTitle || disableConfirm) {
            return <button type="submit" className="button is-info" disabled>Create</button>;
        }

        return <button type="submit" className="button is-info" onClick={() => clickHandler(pages, setPages)}>Create</button>;
    };

    const modalStyle = {
        position: 'fixed',
        top: 100,
        left: 40,
    };

    const content = (pages, setPages) => (
        <div className="box" style={{ minHeight: 100 }}>
            <label htmlFor="title" style={{ color: '#4a4a4a' }}>
                <p>Please enter the new thank you page name</p>
                <div className="is-size-6 columns">
                    <div className="column" style={{ flexGrow: 8 }}>
                        <input className="input" name="title" type="text" value={newTitleRef.current} onInput={(e) => setNewTitle(e.target.value)} />
                        <p className="is-size-7" style={{ color: 'red' }}>{error}</p>
                    </div>
                    <div className="column">
                        {getSubmit(pages, setPages)}
                    </div>
                </div>
            </label>
        </div>
    );

    return (
        <ManageThankYouConsumer>
            {({ list, updateList }) => (
                <PageManageModal
                    button={modalButton}
                    content={content(list, updateList)}
                    title="Create Thank You Page"
                    confirmButtonText="Create"
                    show={showModal}
                    setShow={setShowModal}
                    error={error}
                    modalcardstyle={modalStyle}
                />
            )}
        </ManageThankYouConsumer>
    );
};

export default ThankYouCreateModal;
